import gin from '../img/veterans/michael_gin.jpg';
import ginwebp from '../img/veterans/michael_gin.webp';
import garcia from '../img/veterans/john_garcia.jpg';
import garciawebp from '../img/veterans/john_garcia.webp';
import sterling from '../img/veterans/todd_sterling.jpg';
import sterlingwebp from '../img/veterans/todd_sterling.webp';
import halbrook from '../img/veterans/caje_halbrook.jpg';
import halbrookwebp from '../img/veterans/caje_halbrook.webp';
import gileau from '../img/veterans/ross_gileau.jpg';
import gileauwebp from '../img/veterans/ross_gileau.webp';
import hernandez from '../img/veterans/eduardo_hernandez.jpg';
import hernandezwebp from '../img/veterans/eduardo_hernandez.webp';

const veteransList = {
  gin: {
    name: 'Michael Gin',
    about:
      'Michael served in the U.S. Marine Corps in the Infantry and as a Mortarman. He deployed to Afghanistan, where he assisted the Afghan National Army (ANA) in operations combatting the terrorist threat in the country.<br /><br />When he left the military, Michael used his training and experience to overcome the myriad of obstacles inherent in the transition back into the civilian world.<br /><br />Michael began work with RRDS during a contract providing bullet-resisting panels for all military recruiting stations. Through this and his continued work helping both civilians and military members, he found purpose with the company.<br /><br />Michael Gin is a Marine and a proud member of the RRDS team.',
    image: './img/veterans/michael_gin.jpg',
    imagewebp: './img/veterans/michael_gin.webp',
  },
  garcia: {
    name: 'John Garcia',
    about:
      'John served in the U.S. Air Force as a Tactical Air Control Party (TACP) and trained to become a Joint Terminal Air Controller (JTAC). He operated as a member of the Air Force Special Warfare group.<br /><br />The customs and courtesies he learned in the military helped with his transition back into the civilian world.<br /><br />John feels that the comradery and professional manner of the employees at RRDS create a very welcoming environment for veterans. There is a team environment where everyone values the work of their teammates.<br /><br />RRDS has provided John with an opportunity to remain connected to the military while gaining valuable experience in the defense contracting world.<br /><br />John Garcia is an Airman and a proud member of the RRDS team.',
    image: './img/veterans/john_garcia.jpg',
    imagewebp: './img/veterans/john_garcia.webp',
  },
  sterling: {
    name: 'Todd Sterling',
    about:
      'Todd served in the U.S. Army as a tank crewman, operating throughout Europe.<br /><br />After leaving the military, Todd spent some time weighing his options and moving around before taking on an important position in government contracting.<br /><br />At RRDS, he has found a work environment that feels familiar to his time in the military. He appreciates the fact that the company is there to support the men and women who are out there protecting our country.<br /><br />Todd is grateful for the RRDS culture that is full of friendly, professional employees who are always there to do good work for their customers.<br /><br />Todd Sterling is a Soldier and a proud member of the RRDS team.',
    image: './img/veterans/todd_sterling.jpg',
    imagewebp: './img/veterans/todd_sterling.webp',
  },
  halbrook: {
    name: 'Caje Halbrook',
    about:
      'Caje is a distinguished veteran of the United States Marine Corps, having served as a Corporal in the role of a Landing Support Specialist (MOS 0481). He provided critical logistics support and cargo handling during his deployments. Caje honed his skills in NATO Evacuation training, mastering emergency evacuation procedures.<br /><br />After transitioning to civilian life, he continued to draw upon Marine Corps expertise, making a positive impact in his post-military career. His dedication to supporting the community and contributing to the well-being of others remained unwavering.<br /><br />RRDS INC has created a seamless transition for Caje Halbrook, providing him with a supportive environment that embraces the principles of brotherhood akin to the Marine Corps.',
    image: './img/veterans/caje_halbrook.jpg',
    imagewebp: './img/veterans/caje_halbrook.webp',
  },
  gileau: {
    name: 'Ross Gileau',
    about:
      'Ross served in the U.S. Marine Corps Reserves in the 6th Air Naval Gunfire Liaison Company. He operated in the unit’s S-3 Operations department and coordinated training events for all personnel in the unit as well as organizing events in his community.<br /><br />The honor of serving in the Marine Corps while earning a bachelor’s degree in international business was a great source of pride for both Ross and his family.<br /><br />Ross is thrilled to be working with a team of material experts, as well as other veterans to provide our nation’s men and women in uniform with mission critical operational gear and services. He is excited to be working for a rapidly growing company like RRDS and is eager to play a major part of the long-term strategy for the business.<br /><br />Ross Gileau is a Marine and an enthusiastic member of the RRDS team.',
    image: './img/veterans/ross_gileau.jpg',
    imagewebp: './img/veterans/ross_gileau.webp',
  },
  hernandez: {
    name: 'Eduardo Hernandez',
    about:
      'Eduardo served in the U.S. Army as a transportation specialist. During his military career, he supported logistical operations involving attached combat units and NATO allies.<br /><br />After transitioning back to civilian life, Eduardo wanted to expand his technical skills that would better translate to the civilian world. He then decided to pursue a bachelor’s degree in Supply Chain Management.<br /><br />RRDS is a veteran-friendly workplace that gives veterans the opportunity to continue to serve their country through government contracting. Eduardo is focused on delivering exceptional service to every RRDS customer.<br /><br />Eduardo Hernandez is a Soldier and a proud member of the RRDS team.',
    image: './img/veterans/eduardo_hernandez.jpg',
    imagewebp: './img/veterans/eduardo_hernandez.webp',
  },
};

const images = [
  gin,
  ginwebp,
  garcia,
  garciawebp,
  sterling,
  sterlingwebp,
  halbrook,
  halbrookwebp,
  gileau,
  gileauwebp,
  hernandez,
  hernandezwebp,
];

const preloadImage = src => {
  return new Promise((res, rej) => {
    const img = new Image();
    img.addEventListener('load', () => res(src));
    img.addEventListener('error', err => rej(err));
    img.src = src;
  });
};

Promise.all(images.map(preloadImage)).then(images => {
  return;
});

let canIClickVeteran = true;

const showCorrectVeteran = veteran => {
  const name = document.querySelector('.story__group__name');
  const desc = document.querySelector('.story__group__desc');
  name.textContent = veteransList[veteran].name;
  desc.innerHTML = veteransList[veteran].about;

  // Update the image src and srcset inside the picture tag
  const pictureElement = document.querySelector('.story__group__image');
  const imgElement = pictureElement.querySelector('img');
  const webpSource = pictureElement.querySelector('source[type="image/webp"]');

  // Update the src and srcset attributes
  imgElement.src = veteransList[veteran].image;
  webpSource.srcset = veteransList[veteran].imagewebp;
  canIClickVeteran = true;
};

const veterans = document.querySelectorAll('.meetveterans__thumb');
const veterans__keyboard = document.querySelectorAll(
  '.meetveterans__selector li',
);

const handleVeteranClick = (e, veteran) => {
  let veteranSelected;

  // Check if e.target is the li and find the img inside
  if (e.target.tagName === 'LI') {
    veteranSelected = e.target.querySelector('img');
  }
  // If e.target is directly the img, get data-veteran directly
  else if (e.target.tagName === 'IMG') {
    veteranSelected = veteran;
  }
  if (
    canIClickVeteran &&
    !veteranSelected.classList.contains('meetveterans__active')
  ) {
    canIClickVeteran = false;
    const previousVeteran = document.querySelector('.meetveterans__active');
    previousVeteran.classList.remove('meetveterans__active');
    const previousName = previousVeteran.dataset.veteran;
    const story = document.querySelector('.story__group');
    story.classList.remove(`story__group--${previousName}`);
    veteranSelected.classList.add('meetveterans__active');
    const currentVeteran = veteranSelected.dataset.veteran;
    story.classList.add(`story__group--${currentVeteran}`);
    showCorrectVeteran(currentVeteran);
    // Get the position of the story__group
    const storyPosition = story.getBoundingClientRect().top + window.scrollY;

    // Scroll up to the story__group position minus 72 pixels
    window.scrollTo({
      top: storyPosition - 72,
      behavior: 'smooth',
    });
  }
};

veterans.forEach(veteran => {
  veteran.addEventListener('click', e => {
    e.preventDefault();
    handleVeteranClick(e, veteran);
  });
});

veterans__keyboard.forEach(veteran => {
  // Keydown event listener for Enter and Space
  veteran.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleVeteranClick(e, veteran);
    }
  });
});
